import { z } from 'zod';

export const LocationSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  additionalInfo: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  country: z.string().nullable(),
  longitude: z.number(),
  latitude: z.number(),
  timezoneId: z.string(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional(),
});

export type LocationSchemaType = z.infer<typeof LocationSchema>;

export type LocationFrontendPayload = {
  name: string;
  latitude: number;
  longitude: number;
  additionalInfo?: string;
};

export type LocationParts = {
  id?: string;
  country: string | null;
  state: string | null;
  city: string | null;
};

export type LocationRaw = {
  longitude: number;
  latitude: number;
  name: string;
  additionalInfo: string | null;
  timezoneId: string;
} & LocationParts;
